<template>
  <div class="table-view">
    <div class="table-view__table">
      <table>
        <TablePart
            v-if="undefined !== head"
            containerTag="thead"
            cellTag="th"
            :content="head"
            :serialCallback="isSerial ? () => '№' : null"/>
        <TablePart
            v-if="undefined !== body"
            :content="body"
            :serialCallback="isSerial ? getSerial : null"/>
        <TablePart
            v-if="undefined !== foot"
            containerTag="tfoot"
            :content="foot"
            :serialCallback="isSerial ? () => '№' : null"/>
      </table>
    </div>
    <div class="table-view__pagination">
      <PaginationItems :pages="pages"/>
    </div>
  </div>
</template>

<script setup>
import useCurrentPage from "@/components/table/hooks/useCurrentPage";
import TablePart from "@/components/table/TablePart.vue";
import PaginationItems from "@/components/table/PaginationItems.vue";

/**
 * Usage example:
 * <TableView
 *   :isSerial="true"
 *   :pages="{
 *     size: 10,
 *     total: 10
 *   }"
 *   :head="similar as body"
 *   :body="{
 *     rows: [
 *       {
 *         cells: [
 *           {
 *             content: "",
 *             bind: {},
 *             on: {},
 *           }
 *         ],
 *         bind: {},
 *         on: {},
 *       }
 *     ],
 *     bind: {},
 *     on: {},
 *   }"
 *   :foot="similar as body"/>
 */
const props = defineProps({
  isSerial: {
    type: Boolean,
    default: false,
  },
  pages: Object,
  head: Object,
  body: Object,
  foot: Object,
});

const lastPage = null !== props.pages ? props.pages.total : null;
const currentPage = useCurrentPage(lastPage);

const getSerial = (index) => {
  if (null === props.pages) {
    return index + 1;
  }

  return props.pages.size * (currentPage - 1) + index + 1;
};
</script>

<style lang="scss" scoped>
.table-view {
  .table-view__table {
    margin-bottom: 20px;

    table {
      border-collapse: separate;
      border-spacing: 0 15px;
      width: 100%;
    }
  }
}
</style>